import { gql } from "gql";

export const START_AI_ASSISTANT_CHAT = gql(/* GraphQL */ `
  mutation StartAiAssistantChat {
    startAiAssistantChat {
      id
    }
  }
`);
